export const teacherColumn = [
  {
    title: '教师名称',
    key: 'userName',
    minWidth: 200
  },
  {
    title: '提供方',
    key: 'deptName',
    minWidth: 200
  },
  {
    title: '所属校区',
    key: 'schoolArea',
    minWidth: 200
  }
]; // 教师列表表格column
